import React, {useEffect, useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../_metronic/helpers'
import {Link, useNavigate, useParams} from 'react-router-dom'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {orderDetailAmandemen} from '../../../api/modules/amandemen'
import {useTranslation, initReactI18next} from 'react-i18next'
import axios from 'axios'
import Pagination from '../component/Pagination'
import AddRemoveJadwal from './AddRemoveJadwal'
import {getAccesses} from '../../../api/modules/sip'
import {create, getFile, deleteFile} from '../../../api/modules/file'
import swal from 'sweetalert'
import {Spinner} from 'react-bootstrap'
import i18next from 'i18next'
import InputGroup from 'react-bootstrap/InputGroup'
import CustomUseEffect from './../so/CustomUseEffect'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover'
import {useAppSelector} from 'src/redux/hooks'
import {authSelector} from 'src/redux/slices/authSlices'
import dateformat from 'src/utils/dateformat'

const TableRevisiSIP: React.FC = () => {
  const {roleId} = useAppSelector(authSelector)
  const params = useParams()
  const [tooltip, setTooltip] = useState('Open')
  const handleOpen = (e: any) => {
    const icon = e.target
    if (icon.classList.contains('iconArow')) {
      icon?.classList.remove('iconArow')
      icon?.classList.add('iconArowOpen')
      setTooltip('Close')
    } else {
      icon?.classList.remove('iconArowOpen')
      icon?.classList.add('iconArow')
      setTooltip('Open')
    }
    const target = e.currentTarget.getAttribute('data-target')
    const fold = document.getElementById(target)
    fold?.classList.toggle('fold-open')
  }
  const handleToAmandemen = () => {
    let paramid = params.id
    if (itemIndex.length > 0) {
      let tempids: any[] = []
      itemIndex.forEach((data: any) => {
        SIP[data].amendment_items.forEach((item: any) => {
          tempids.push(item.id)
        })
      })
      sessionStorage.setItem('idarray', JSON.stringify(tempids))
      sessionStorage.setItem('po', paramid!)
      navigate('/management/order/amandemen')
    }
  }

  const navigate = useNavigate()

  const {t} = useTranslation()
  const [loadingDownload, setLoadingDownload] = useState(false)

  const [SIP, setSIP] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const [isFailed, setIsFailed] = useState(false)
  const [numberURL, setNumberURL] = useState([])
  const [showJadwal, setShowJadwal] = useState(false)
  const [jadwalID, setJadwalID] = useState('')
  const [roleUser, setRoleUser] = useState('')
  const [accesses, setAccesses] = useState<any>()
  const [idOrder, setIDOrder] = useState('')
  const [showUpload, setShowUpload] = useState(false)
  const [allFiles, setAllFiles] = useState([])
  const [param, setParam] = useState('')
  const [dateNow, setDateNow] = useState('')
  const [itemIndex, setItemIndex] = useState<any[]>([])

  const tampilUpload = async (id: any, paramm: any) => {
    setIDOrder(id)
    await getFile(paramm, id, localStorage.getItem('credential')!).then((res) => {
      setAllFiles(res.data.data)
      setShowUpload(true)
    })
  }

  const [filterAsc, setFilterAsc] = useState<any>('')
  const [filterCus, setFilterCus] = useState<any>('')

  const getOrder = async () => {
    setLoading(true)
    setIsFailed(false)
    await orderDetailAmandemen(params.id, 'false')
      .then((res: any) => {
        setSIP(res.data.data.children)
      })
      .catch((err: any) => {
        setIsFailed(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const dateFormatting = (date: any) => {
    let today = new Date(date)
    let dd = String(today.getDate()).padStart(2, '0')
    let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    let yyyy = today.getFullYear()
    return dd + '-' + mm + '-' + yyyy
  }

  CustomUseEffect(() => {
    getOrder()
  }, [filterAsc, filterCus])

  const [language, setLanguage] = useState<any>()
  const [provinceName, setProvinceName] = useState('')
  const [cityName, setCityName] = useState('')
  const [productName, setProductName] = useState('')
  const [requestQuantum, setReqeustQuantum] = useState('')
  const [fixedQuantum, setFixedQuantum] = useState('')
  const [idSektor, setIDSector] = useState(0)

  const formattingTon = (ton: any) => {
    let tempTon = parseFloat(ton)
    let temp = ''
    if (i18next.language == 'en') {
      temp = tempTon.toLocaleString('en', {maximumFractionDigits: 4})
    } else {
      temp = tempTon.toLocaleString('id', {maximumFractionDigits: 4})
    }
    setFixedQuantum(temp)
  }

  useEffect(() => {
    const interval = setInterval(() => {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split('~#~').shift()
      }
      let language = getCookie('i18next')
      setLanguage(language)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    const role = () => {
      const role: any = localStorage.getItem('role-flag')
      setRoleUser(role)
    }

    const getAccessMenu = async () => {
      setLoading(true)
      const res = await getAccesses(roleId)
      setAccesses(res.data.data)
    }

    let today = new Date()
    let dd = String(today.getDate()).padStart(2, '0')
    let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    let yyyy = today.getFullYear()
    setDateNow(dd + '-' + mm + '-' + yyyy)
    getAccessMenu()
    role()
    getOrder()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const paginateNumber = async (number: any) => {
    if (number == null || number == 'null') {
      return
    }
    setLoading(true)

    const res = await axios.get(
      `${number}&credentials=${localStorage.getItem(
        'credential'
      )}&SIP_number=${searchSIP}&po_number=${searchOrderNumber}&from_date=${searchDate}&to_date=${searchDate2}&sales_org_code=${searchAnper}&customer_name=${searchBuyer}&perihal=${searchRegarding}&total_quantum=${searchQuantum}&price=${searchPrice}&estimate_date=${searchEst}&status=${searchStatus}&&sector_id=${searchSector}&product_type=${searchPtype}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )
    setSIP(res.data.data.data)
    setLoading(false)
    setNumberURL(res.data.data.links)
  }

  //#region state for search
  const [searchSIP, setSearchSIP] = useState('')
  const [searchOrderNumber, setSearchOrderNumber] = useState('')
  const [searchAnper, setSearchAnper] = useState('')
  const [searchStatus, setSearchStatus] = useState('')
  const [searchDate, setSearchDate] = useState('')
  const [searchDate2, setSearchDate2] = useState('')
  const [searchBuyer, setSearchBuyer] = useState('')
  const [searchRegarding, setSearchRegarding] = useState('')
  const [searchQuantum, setSearchQuantum] = useState('')
  const [searchPrice, setSearchPrice] = useState('')
  const [searchEst, setSearchEst] = useState('')
  const [searchSector, setSearchSector] = useState('')
  const [searchPtype, setSearchPtype] = useState('')

  // useEffect(() => {
  //   const getData = setTimeout(async () => {
  //     setIsFailed(false)
  //     setLoading(true)
  //     const tmpOrderNumber = searchOrderNumber.replace('A', '').replace('a', '')
  //     await getSIPSearch(
  //       localStorage.getItem('credential')!,
  //       tmpOrderNumber,
  //       searchDate,
  //       searchDate2,
  //       searchAnper,
  //       searchBuyer,
  //       searchRegarding,
  //       searchQuantum,
  //       searchEst,
  //       searchStatus,
  //       searchSector,
  //       searchPtype
  //     )
  //       .then((res: any) => {
  //         console.log(res.data.data)
  //         setSIP(res.data.data.data)
  //         setNumberURL(res.data.data.links)
  //       })
  //       .catch((err: any) => {
  //         console.log(err)
  //         setIsFailed(true)
  //       })
  //       .finally(() => {
  //         setLoading(false)
  //       })
  //   }, 1000)

  //   return () => clearTimeout(getData)
  // }, [
  //   searchSIP,
  //   searchOrderNumber,
  //   searchDate,
  //   searchDate2,
  //   searchAnper,
  //   searchBuyer,
  //   searchRegarding,
  //   searchQuantum,
  //   searchPrice,
  //   searchEst,
  //   searchStatus,
  //   searchSector,
  //   searchPtype
  // ])
  //#endregion

  const handleDownload = async () => {
    setLoadingDownload(true)

    let data = {
      SIP_number: searchSIP == '' ? undefined : searchSIP,
      po_number: searchOrderNumber == '' ? undefined : searchOrderNumber,
      from_date: searchDate == '' ? undefined : searchDate,
      to_date: searchDate2 == '' ? undefined : searchDate2,
      sales_org_name: searchAnper == '' ? undefined : searchAnper,
      customer_name: searchBuyer == '' ? undefined : searchBuyer,
      perihal: searchRegarding == '' ? undefined : searchRegarding,
      total_quantum: searchQuantum == '' ? undefined : searchQuantum,
      price: searchPrice == '' ? undefined : searchPrice,
      estimate_date: searchEst == '' ? undefined : searchEst,
      status: searchStatus == '' ? undefined : searchStatus,
      credentials: localStorage.getItem('credential'),
    }

    try {
      const res = await axios({
        url: `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/sip_order/export`,
        method: 'GET',
        params: data,
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      })
      const href = URL.createObjectURL(res.data)

      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', `PI_SIP_Order_${dateNow}.xlsx`)
      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      URL.revokeObjectURL(href)
      setLoadingDownload(false)
    } catch {
      swal({
        title: t('Export Failed'),
        icon: 'error',
      })
      setLoadingDownload(false)
    }
  }

  const [showDetail, setShowDetail] = useState(false)
  const [tempDetail, setTempDetail] = useState<any>([])
  const [showCommentCust, setShowCommentCust] = useState(false)

  const handleShowValue = (enduser: any) => {
    let temparray: any[] = enduser.split(',')
    let temp = ''
    temparray.forEach((element: any, index: any) => {
      if (index + 1 == temparray.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  const [buttonFlag, setButtonFlag] = useState(false)

  const onclickCheckBox = (id: any) => {
    const isChecked = document.getElementById(`checkbox${id}`) as HTMLInputElement
    const temp = isChecked.value
    const tempIndex: any[] = itemIndex
    if (isChecked.checked) {
      tempIndex.push(temp)
      setItemIndex(tempIndex)
    } else {
      const tempID = tempIndex.indexOf(temp)!
      tempIndex.splice(tempID, 1)
      setItemIndex(tempIndex)
    }
    if (tempIndex.length > 0) setButtonFlag(true)
    else setButtonFlag(false)
  }

  return (
    <div>
      <div className='card-body py-3'>
        <div className='tableTest mt-5 bdr'>
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 border-bottom sticky-top'>
            <thead>
              <tr className='fw-bold  d-flex jusify-content-center w-100 align-items-center'>
                <th className='td-order-2 text-center th-freeze d-flex justify-content-center align-items-center'>
                  {t('No. SIP')}
                  {filterAsc == '' || filterAsc == 'desc' ? (
                    <button
                      className='bg-transparent border-0'
                      data-bs-toggle='tooltip'
                      data-bs-placement='top'
                      data-bs-trigger='hover'
                      title={t('Sort')}
                      onClick={() => setFilterAsc('asc')}
                    >
                      <KTSVG
                        path='/media/icons/duotune/sort-down-alt.svg'
                        className='svg-icon-3 ms-1'
                      />
                    </button>
                  ) : (
                    <button
                      className='bg-transparent border-0'
                      data-bs-toggle='tooltip'
                      data-bs-placement='top'
                      data-bs-trigger='hover'
                      title={t('Sort')}
                      onClick={() => setFilterAsc('desc')}
                    >
                      <KTSVG
                        path='/media/icons/duotune/sort-up-alt.svg'
                        className='svg-icon-3 ms-1'
                      />
                    </button>
                  )}
                </th>
                <th className='td-order-6 text-center th-freeze'>{t('order number')}</th>
                <th className='td-order-4 text-center th-freeze d-flex justify-content-center align-items-center'>
                  {t('order-pelanggan')}
                  {filterCus == '' || filterCus == 'desc' ? (
                    <button
                      className='bg-transparent border-0'
                      data-bs-toggle='tooltip'
                      data-bs-placement='top'
                      data-bs-trigger='hover'
                      title={t('Sort')}
                      onClick={() => setFilterCus('asc')}
                    >
                      <KTSVG
                        path='/media/icons/duotune/sort-down-alt.svg'
                        className='svg-icon-3 ms-1'
                      />
                    </button>
                  ) : (
                    <button
                      className='bg-transparent border-0'
                      data-bs-toggle='tooltip'
                      data-bs-placement='top'
                      data-bs-trigger='hover'
                      title={t('Sort')}
                      onClick={() => setFilterCus('desc')}
                    >
                      <KTSVG
                        path='/media/icons/duotune/sort-up-alt.svg'
                        className='svg-icon-3 ms-1'
                      />
                    </button>
                  )}
                </th>
                <th className='td-order-2 text-center'>{t('order-perihal')}</th>
                <th className='td-order-3 text-center'>{t('Sektor')}</th>
                <th className='td-order-3 text-center'>Sales Org</th>
                <th className='td-order-2 text-center'>{t('order-tanggal')}</th>
                <th className='td-order-2 text-center'>{t('Tanggal Pengajuan')}</th>
                <th className='td-order-2 text-center'>{t('Start-Date')}</th>
                <th className='td-order-2 text-center'>{t('End-Date')}</th>
                <th className='td-order-2 text-center'>Total {t('kontrak-kuantum')}</th>
                <th className='td-order-2 text-center'>Total {t('kontrak-harga')}</th>
                <th className='td-order-3 text-center'>Status</th>
                <th className='td-order-2 text-center'>{t('order-aksi')}</th>
              </tr>
            </thead>
          </table>
          <table className='table'>
            <tr className='d-flex jusify-content-center w-100 align-items-center'>
              <td className='td-order-2 text-center td-freeze pm-0'>
                <InputGroup className='p-0'>
                  <InputGroup.Text className='ps-2 pe-0 bg-transparent'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='16'
                      fill='currentColor'
                      className='bi bi-search'
                      viewBox='0 0 16 16'
                    >
                      <path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
                    </svg>
                  </InputGroup.Text>
                  <Form.Control
                    className='border border-start-0'
                    type='text'
                    placeholder={t('No. SIP')}
                  />
                </InputGroup>
              </td>
              <td className='td-order-6 text-center td-freeze pm-0'>
                <InputGroup className='p-0'>
                  <InputGroup.Text className='ps-2 pe-0 bg-transparent'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='16'
                      fill='currentColor'
                      className='bi bi-search'
                      viewBox='0 0 16 16'
                    >
                      <path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
                    </svg>
                  </InputGroup.Text>
                  <Form.Control
                    className='border border-start-0'
                    type='text'
                    placeholder={t('order number')}
                  />
                </InputGroup>
              </td>
              <td className='td-order-4 text-center td-freeze pm-0'>
                <InputGroup className='p-0'>
                  <InputGroup.Text className='ps-2 pe-0 bg-transparent'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='16'
                      fill='currentColor'
                      className='bi bi-search'
                      viewBox='0 0 16 16'
                    >
                      <path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
                    </svg>
                  </InputGroup.Text>
                  <Form.Control
                    className='border border-start-0'
                    type='text'
                    placeholder={t('order-pelanggan')}
                  />
                </InputGroup>
              </td>
              <td className='td-order-2 text-center pm-0'>
                <InputGroup className='p-0'>
                  <InputGroup.Text className='ps-2 pe-0 bg-transparent'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='16'
                      fill='currentColor'
                      className='bi bi-search'
                      viewBox='0 0 16 16'
                    >
                      <path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
                    </svg>
                  </InputGroup.Text>
                  <Form.Control
                    className='border border-start-0'
                    type='text'
                    placeholder={t('order-perihal')}
                  />
                </InputGroup>
              </td>
              <td className='td-order-3 text-center pm-0'>
                <InputGroup className='p-0'>
                  <InputGroup.Text className='ps-2 pe-0 bg-transparent'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='16'
                      fill='currentColor'
                      className='bi bi-search'
                      viewBox='0 0 16 16'
                    >
                      <path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
                    </svg>
                  </InputGroup.Text>
                  <Form.Control
                    className='border border-start-0'
                    type='text'
                    placeholder={t('Sektor')}
                  />
                </InputGroup>
              </td>
              <td className='td-order-3 text-center pm-0'>
                <InputGroup className='p-0'>
                  <InputGroup.Text className='ps-2 pe-0 bg-transparent'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='16'
                      fill='currentColor'
                      className='bi bi-search'
                      viewBox='0 0 16 16'
                    >
                      <path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
                    </svg>
                  </InputGroup.Text>
                  <Form.Control
                    className='border border-start-0'
                    type='text'
                    placeholder={'Sales Org'}
                  />
                </InputGroup>
              </td>
              <td className='td-order-2 text-center pm-0'>
                <InputGroup className='p-0'>
                  <InputGroup.Text className='ps-2 pe-0 bg-transparent '>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='16'
                      fill='currentColor'
                      className='bi bi-search'
                      viewBox='0 0 16 16'
                    >
                      <path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
                    </svg>
                  </InputGroup.Text>
                  <Form.Control
                    className='border border-start-0'
                    type='text'
                    placeholder={t('order-tanggal')}
                  />
                </InputGroup>
              </td>
              <td className='td-order-2 text-center pm-0'>
                <InputGroup className='p-0'>
                  <InputGroup.Text className='ps-2 pe-0 bg-transparent'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='16'
                      fill='currentColor'
                      className='bi bi-search'
                      viewBox='0 0 16 16'
                    >
                      <path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
                    </svg>
                  </InputGroup.Text>
                  <Form.Control
                    className='border border-start-0'
                    type='text'
                    placeholder={t('Tanggal Pengajuan')}
                  />
                </InputGroup>
              </td>
              <td className='td-order-2 text-center pm-0'>
                <InputGroup className='p-0'>
                  <InputGroup.Text className='ps-2 pe-0 bg-transparent'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='16'
                      fill='currentColor'
                      className='bi bi-search'
                      viewBox='0 0 16 16'
                    >
                      <path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
                    </svg>
                  </InputGroup.Text>
                  <Form.Control
                    className='border border-start-0'
                    type='text'
                    placeholder={t('Start-Date')}
                  />
                </InputGroup>
              </td>
              <td className='td-order-2 text-center pm-0'>
                <InputGroup className='p-0'>
                  <InputGroup.Text className='ps-2 pe-0 bg-transparent'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='16'
                      fill='currentColor'
                      className='bi bi-search'
                      viewBox='0 0 16 16'
                    >
                      <path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
                    </svg>
                  </InputGroup.Text>
                  <Form.Control
                    className='border border-start-0'
                    type='text'
                    placeholder={t('End-Date')}
                  />
                </InputGroup>
              </td>
              <td className='td-order-2 text-center pm-0'>
                <InputGroup className='p-0'>
                  <InputGroup.Text className='ps-2 pe-0 bg-transparent'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='16'
                      fill='currentColor'
                      className='bi bi-search'
                      viewBox='0 0 16 16'
                    >
                      <path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
                    </svg>
                  </InputGroup.Text>
                  <Form.Control
                    className='border border-start-0'
                    type='text'
                    placeholder={'Total ' + t('kontrak-kuantum')}
                  />
                </InputGroup>
              </td>
              <td className='td-order-2 text-center pm-0'>
                <InputGroup className='p-0'>
                  <InputGroup.Text className='ps-2 pe-0 bg-transparent'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='16'
                      fill='currentColor'
                      className='bi bi-search'
                      viewBox='0 0 16 16'
                    >
                      <path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
                    </svg>
                  </InputGroup.Text>
                  <Form.Control
                    className='border border-start-0'
                    type='text'
                    placeholder={'Total ' + t('kontrak-harga')}
                  />
                </InputGroup>
              </td>
              <td className='td-order-3 text-center pm-0'>
                <InputGroup className='p-0'>
                  <InputGroup.Text className='ps-2 pe-0 bg-transparent'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='16'
                      fill='currentColor'
                      className='bi bi-search'
                      viewBox='0 0 16 16'
                    >
                      <path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
                    </svg>
                  </InputGroup.Text>
                  <Form.Control
                    className='border border-start-0'
                    type='text'
                    placeholder={'Status'}
                  />
                </InputGroup>
              </td>
              <td className='td-order-2 text-center'>
                <div className='py-5'></div>
              </td>
            </tr>
          </table>
          {/* End Table Head */}

          {/* Table Content */}

          {/* map data from json */}
          {loading ? (
            <div className='d-flex justify-content-center py-10'>
              <div className='lds-ellipsis'>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          ) : isFailed ? (
            <tr className='d-flex justify-content-center w-100 align-items-center'>
              <td className='text-center' colSpan={13}>
                {t('failed-to-load')}
                <br />
                <br />
                <button
                  className='btn btn-sm btn-primary ms-2'
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  data-bs-trigger='hover'
                  title={t('reload table')}
                  onClick={() => {
                    getOrder()
                  }}
                >
                  <i className='fas fa-sync-alt'></i>
                </button>
              </td>
            </tr>
          ) : SIP.length === 0 ? (
            <tr className='d-flex justify-content-center w-100 align-items-center'>
              <td className='text-center' colSpan={13}>
                {t('data-tidak-ada')}
                <br />
                <br />
                <button
                  className='btn btn-sm btn-primary ms-2'
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  data-bs-trigger='hover'
                  title={t('reload table')}
                  onClick={() => {
                    getOrder()
                  }}
                >
                  <i className='fas fa-sync-alt'></i>
                </button>
              </td>
            </tr>
          ) : (
            SIP.map((item, _index) => (
              <>
                {_index % 2 == 0 ? (
                  <>
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 bg-secondary'>
                      <tr className='d-flex jusify-content-center w-100 align-items-center'>
                        <td className='view td-order-2 td-freeze bg-secondary d-flex'>
                          <div className='d-flex justify-content-center align-items-center p-3'>
                            <input
                              className='form-check-input me-2'
                              type='checkbox'
                              id={'checkbox' + _index}
                              value={_index}
                              onClick={() => onclickCheckBox(_index)}
                            />
                            <button
                              className='iconArow d-flex justify-content-center align-items-center me-2'
                              data-target={'target' + item['id']}
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t(tooltip)}
                              onClick={handleOpen}
                            >
                              {/* <KTSVG
                                    path='/media/icons/duotune/arrows/arrow-down.svg'
                                    className='svg-1'
                                  /> */}
                            </button>
                            <span
                              className=' fw-semibold p-0 fs-6'
                              // onClick={() => handleToAmandemen()}
                            >
                              SIP{item['SIP_number']}
                            </span>
                          </div>
                        </td>
                        <td className='td-order-6 text-center td-freeze bg-secondary'>
                          <span className='d-block fs-6'>
                            A{item['pengajuan_order']?.po_number}
                          </span>
                        </td>
                        <td className='td-order-4 text-center td-freeze bg-secondary'>
                          <span className=' fw-semibold  d-block fs-6'>
                            {item['customer']?.title} {item['customer']?.name}
                          </span>
                        </td>
                        <td className='td-order-2 text-center'>
                          <span className='d-block fs-6'>
                            {item['perihal'] == 'PO001' ? (
                              <span className='badge badge-light-success'>{t('Penjualan')}</span>
                            ) : (
                              <span className='badge badge-light-primary'>
                                {t('Non-Penjualan')}
                              </span>
                            )}
                          </span>
                        </td>
                        <td className='td-order-3 text-center'>
                          <span className=' fw-semibold  d-block fs-6'>{t(item.sector?.name)}</span>
                        </td>
                        <td className='td-order-3 text-center'>
                          <span className=' fw-semibold  d-block fs-6'>{item['anper']?.name}</span>
                        </td>
                        <td className='td-order-2 text-center'>
                          <span className=' fw-semibold  d-block fs-6'>
                            {item.created_at.slice(0, 10)}
                          </span>
                        </td>
                        <td className='td-order-2 text-center'>
                          <span className=' fw-semibold  d-block fs-6'>
                            {item['estimate_date']?.slice(0, 10)}
                          </span>
                        </td>
                        <td className='td-order-2 text-center'>
                          <span className=' fw-semibold  d-block fs-6'>
                            {item.valid_date_from == null
                              ? ''
                              : dateFormatting(item.valid_date_from)}
                          </span>
                        </td>
                        <td className='td-order-2 text-center'>
                          <span className=' fw-semibold  d-block fs-6'>
                            {item.valid_date_to == null ? '' : dateFormatting(item.valid_date_to)}
                          </span>
                        </td>
                        <td className='td-order-2 text-center'>
                          <span className=' fw-semibold  d-block fs-6'>
                            {i18next.language === 'en'
                              ? item.total_quantum?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : item.total_quantum?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })}{' '}
                            {item.sector_id === 3 ? 'MT' : 'Ton'}
                          </span>
                        </td>
                        <td className='td-order-2 text-center'>
                          <span className=' fw-semibold  d-block fs-6'>
                            {(item.sector_id != 3 ? 'Rp' : 'USD') +
                              (i18next.language === 'en'
                                ? item.total_price?.toLocaleString('en', {maximumFractionDigits: 4})
                                : item.total_price?.toLocaleString('id', {
                                    maximumFractionDigits: 4,
                                  }))}
                          </span>
                        </td>
                        <td className='td-order-3 text-center'>
                          <span className='d-block fs-6'>
                            {item['status_text'] == 'Pengajuan Amandemen' ||
                            item['status_text'] == 'Amandemen' ||
                            item['status_text'] == 'Diamandemen Customer' ||
                            item['status_text'] == 'Telah Diamandemen' ? (
                              <span className='badge badge-light-info'>{t('Amandemen')}</span>
                            ) : item['status'] === 1 ? (
                              <span className='badge badge-light-primary'>
                                {t(item['status_text'])}
                              </span>
                            ) : item['status'] === 2 ? (
                              <span className='badge badge-light-warning'>
                                {t(item['status_text'])}
                              </span>
                            ) : item['status'] === 3 ? (
                              <span className='badge badge-light-primary'>
                                {t(item['status_text'])}
                              </span>
                            ) : item['status'] === 4 ? (
                              <span className='badge badge-light-success'>
                                {t(item['status_text'])}
                              </span>
                            ) : item['status'] === 5 ? (
                              <span className='badge badge-light-success'>
                                {t(item['status_text'])}
                              </span>
                            ) : item['status'] === 6 ? (
                              <span className='badge badge-light-primary'>
                                {t(item['status_text'])}
                              </span>
                            ) : item['status'] === 7 ? (
                              <span className='badge badge-light-warning'>
                                {t(item['status_text'])}
                              </span>
                            ) : item['status'] === 8 ? (
                              <span className='badge badge-light-primary'>
                                {t(item['status_text'])}
                              </span>
                            ) : item['status'] === 9 ? (
                              <span className='badge badge-light-warning'>
                                {t(item['status_text'])}
                              </span>
                            ) : (
                              <span className='badge badge-light-danger'>
                                {t(item['status_text'])}
                              </span>
                            )}
                          </span>
                        </td>
                        <td className='td-order-2 text-center'>
                          <div
                            className='d-flex p-0 justify-content-center'
                            style={{marginTop: '1px', marginBottom: '1.5px'}}
                          >
                            {/* <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title='Detail'
                              onClick={() => handleToAmandemen()}
                            >
                              <KTSVG
                                path='/media/icons/duotune/file-text-fill.svg'
                                className='svg-icon-3'
                              />
                            </button> */}

                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('order-lampiran')}
                              onClick={() => {
                                tampilUpload(item.id, 'header')
                              }}
                            >
                              <KTSVG
                                path='/media/icons/duotune/archive-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    </table>
                    <div className='d-flex lefttt'>
                      <div className='table-responsive sub-table' style={{borderRadius: '8px'}}>
                        <table className='table'>
                          <tr className='fold' id={'target' + item['id']}>
                            <td className='fold-wrapperContent'>
                              <div className='fold-content' style={{padding: '0'}}>
                                <table className='table-border table-fix'>
                                  {/* begin::Table head */}
                                  <thead>
                                    <tr className='fw-bold  border-bottom'>
                                      <th
                                        className='text-center th2-freeze'
                                        style={{padding: '1rem 2.5rem'}}
                                      >
                                        {t('sub-order-item')}
                                      </th>
                                      <th
                                        className='text-center th2-freeze'
                                        style={{padding: '1rem 2.5rem'}}
                                      >
                                        Sales Org
                                      </th>
                                      <th
                                        className='text-center th2-freeze'
                                        style={{padding: '1rem 2.5rem'}}
                                      >
                                        {t('sub-order-incoterm')}
                                      </th>
                                      {item?.sector?.id != 3 && (
                                        <th
                                          className='text-center'
                                          style={{padding: '1rem 2.5rem'}}
                                        >
                                          {t('sub-order-wilayah')}
                                        </th>
                                      )}
                                      <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                        {t('sub-order-jenis')}
                                      </th>
                                      <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                        {t('Product Code')}
                                      </th>
                                      <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                        {t('sub-order-produk')}
                                      </th>
                                      <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                        {t('sub-order-spek')}
                                      </th>
                                      {item.sector_id != 2 ? (
                                        <>
                                          <th
                                            className='text-center'
                                            style={{padding: '1rem 2.5rem'}}
                                          >
                                            {t('kontrak-kuantum')}
                                          </th>
                                          <th
                                            className='text-center'
                                            style={{padding: '1rem 2.5rem'}}
                                          >
                                            {t('sub-order-kuantumD')}
                                          </th>
                                          <th
                                            className='text-center'
                                            style={{padding: '1rem 2.5rem'}}
                                          >
                                            {t('kontrak-harga')}
                                          </th>
                                          <th
                                            className='text-center'
                                            style={{padding: '1rem 2.5rem'}}
                                          >
                                            {t('sub-order-hargaD')}
                                          </th>
                                        </>
                                      ) : (
                                        <>
                                          <th
                                            className='text-center'
                                            style={{padding: '1rem 2.5rem'}}
                                          >
                                            {t('kontrak-kuantum')}
                                          </th>
                                          <th
                                            className='text-center'
                                            style={{padding: '1rem 2.5rem'}}
                                          >
                                            {t('kontrak-harga')}
                                          </th>
                                        </>
                                      )}
                                      {item.sector?.id == 1 || item.sector?.id == 3 ? (
                                        <></>
                                      ) : (
                                        <th
                                          className='text-center'
                                          style={{padding: '1rem 2.5rem'}}
                                        >
                                          {t('sub-order-gudang')}
                                        </th>
                                      )}
                                      <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                        Status
                                      </th>
                                      <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                        {t('order-aksi')}
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {item?.amendment_items?.map((subItem: any, _index: number) => (
                                      <tr key={subItem?.id ?? _index}>
                                        <td className='text-center td2-freeze'>
                                          {/* {subItem.id} */}
                                          {_index + 1}
                                        </td>
                                        {/* <td className='text-center'>{subItem.contract_id}</td> */}
                                        {/* {item.customer?.customer_account_group != "AR03" ? (
                                        <></>
                                      ) : (
                                        <td className='text-center'>{subItem.produsen?.name}</td>
                                      )} */}
                                        <td className='text-center td2-freeze'>
                                          {subItem.produsen?.name}
                                        </td>
                                        {subItem.sector_id == 2 ? (
                                          <>
                                            {subItem.incoterm2 == null ? (
                                              <td className='text-center td2-freeze'>
                                                {subItem.incoterm1?.code}-{subItem.incoterm2_id}
                                              </td>
                                            ) : (
                                              <td className='text-center td2-freeze'>
                                                {subItem.incoterm1?.code}-{subItem.incoterm2?.code}
                                              </td>
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            {subItem.incoterm2 == null ? (
                                              <td className='text-center td2-freeze'>
                                                {subItem.incoterm1?.code}
                                                {subItem.incoterm2_id == null ||
                                                subItem.incoterm2_id == '0'
                                                  ? ''
                                                  : '-' + subItem.incoterm2_id}
                                              </td>
                                            ) : (
                                              <td className='text-center td2-freeze'>
                                                {subItem.incoterm1?.code}-{subItem.incoterm2?.code}
                                              </td>
                                            )}
                                          </>
                                        )}
                                        {subItem.sector_id != 3 && (
                                          <td className='text-center'>
                                            {subItem.province?.region_name},{' '}
                                            {subItem.city?.city_name}
                                          </td>
                                        )}
                                        <td className='text-center'>{subItem.product_type_desc}</td>
                                        <td className='text-center'>
                                          {parseInt(subItem.material_number) == 0
                                            ? ''
                                            : subItem.material_number.slice(-7)}
                                        </td>
                                        <td className='text-center'>{subItem.product_name}</td>
                                        <td className='text-center'>
                                          <OverlayTrigger
                                            trigger='hover'
                                            key={_index}
                                            placement='right'
                                            overlay={
                                              <Popover id={`popover-positioned-${_index}`}>
                                                <Popover.Body>{subItem.product_spec}</Popover.Body>
                                              </Popover>
                                            }
                                          >
                                            <p className='spec-slicee'>{subItem.product_spec}</p>
                                          </OverlayTrigger>
                                        </td>
                                        {item.sector_id != 2 ? (
                                          <>
                                            <td className='text-center'>
                                              {i18next.language === 'en'
                                                ? subItem.request_quantum?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  })
                                                : subItem.request_quantum?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  })}{' '}
                                              {subItem.sector_id === 3 ? 'MT' : 'Ton'}
                                            </td>
                                            <td className='text-center'>
                                              {i18next.language === 'en'
                                                ? subItem.fixed_quantum?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  })
                                                : subItem.fixed_quantum?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  })}{' '}
                                              {subItem.sector_id === 3 ? 'MT' : 'Ton'}
                                            </td>
                                            <td className='text-center'>
                                              {subItem.is_formulated_price ? (
                                                <>{t('Formulated Price')}</>
                                              ) : (
                                                <>
                                                  {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                                    (i18next.language === 'en'
                                                      ? subItem.request_price.toLocaleString('en', {
                                                          maximumFractionDigits: 4,
                                                        })
                                                      : subItem.request_price.toLocaleString('id', {
                                                          maximumFractionDigits: 4,
                                                        })) +
                                                    (item.sector_id != 3 ? '/Ton' : '/MT')}
                                                </>
                                              )}
                                            </td>
                                            <td className='text-center'>
                                              {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                                (i18next.language === 'en'
                                                  ? subItem.fixed_price.toLocaleString('en', {
                                                      maximumFractionDigits: 4,
                                                    })
                                                  : subItem.fixed_price.toLocaleString('id', {
                                                      maximumFractionDigits: 4,
                                                    })) +
                                                (item.sector_id != 3 ? '/Ton' : '/MT')}
                                            </td>
                                          </>
                                        ) : (
                                          <>
                                            <td className='text-center'>
                                              {i18next.language === 'en'
                                                ? subItem.fixed_quantum?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  })
                                                : subItem.fixed_quantum?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  })}{' '}
                                              {subItem.sector_id === 3 ? 'MT' : 'Ton'}
                                            </td>
                                            <td className='text-center'>
                                              {'Rp' + i18next.language === 'en'
                                                ? subItem.fixed_price.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  })
                                                : subItem.fixed_price.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  })}
                                              /{subItem.sector_id === 3 ? 'MT' : 'Ton'}
                                            </td>
                                          </>
                                        )}
                                        {item.sector?.id == 1 || item.sector?.id == 3 ? (
                                          <></>
                                        ) : (
                                          <td className='text-center'>{subItem.plant_desc}</td>
                                        )}
                                        <td className='text-center'>
                                          <span className='d-block '>
                                            {subItem['status_text'] == 'Pengajuan Amandemen' ||
                                            subItem['status_text'] == 'Amandemen' ||
                                            subItem['status_text'] == 'Diamandemen Customer' ||
                                            subItem['status_text'] == 'Telah Diamandemen' ? (
                                              <span className='badge badge-light-info'>
                                                {t('Amandemen')}
                                              </span>
                                            ) : subItem['status'] == '0' ? (
                                              <span className='badge badge-light-success'>
                                                {t(subItem['status_text'])}
                                              </span>
                                            ) : subItem['status'] == '1' ? (
                                              <span className='badge badge-light-primary'>
                                                {t(subItem['status_text'])}
                                              </span>
                                            ) : subItem['status'] == '2' ? (
                                              <span className='badge badge-light-warning'>
                                                {t(subItem['status_text'])}
                                              </span>
                                            ) : subItem['status'] == '3' ? (
                                              <span className='badge badge-light-warning'>
                                                {t(subItem['status_text'])}
                                              </span>
                                            ) : subItem['status'] == '4' ? (
                                              <>
                                                {subItem['status_text'].match('Partially') ? (
                                                  <span className='badge badge-light-warning'>
                                                    {t(subItem['status_text'])}
                                                  </span>
                                                ) : (
                                                  <span className='badge badge-light-success'>
                                                    {t(subItem['status_text'])}
                                                  </span>
                                                )}
                                              </>
                                            ) : subItem['status'] == '5' ? (
                                              <span className='badge badge-light-success'>
                                                {t(subItem['status_text'])}
                                              </span>
                                            ) : subItem['status'] == '6' ? (
                                              <span className='badge badge-light-success'>
                                                {t(subItem['status_text'])}
                                              </span>
                                            ) : subItem['status'] == '7' ? (
                                              <span className='badge badge-light-success'>
                                                {t(subItem['status_text'])}
                                              </span>
                                            ) : (
                                              <span className='badge badge-light-danger'>
                                                {t(subItem['status_text'])}
                                              </span>
                                            )}
                                          </span>
                                        </td>
                                        <td className='text-center'>
                                          <div className='d-flex justify-content-center align-items-center'>
                                            <button
                                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-1 me-1'
                                              data-bs-toggle='tooltip'
                                              data-bs-placement='top'
                                              data-bs-trigger='hover'
                                              title='Detail'
                                              onClick={() => {
                                                setTempDetail(subItem)
                                                setShowDetail(true)
                                              }}
                                            >
                                              <KTSVG
                                                path='/media/icons/duotune/file-text-fill.svg'
                                                className='svg-icon-3'
                                              />
                                            </button>
                                            <button
                                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                              data-bs-toggle='tooltip'
                                              data-bs-placement='top'
                                              data-bs-trigger='hover'
                                              title={t('order-lampiran')}
                                              onClick={() => {
                                                tampilUpload(subItem.id, 'order-item')
                                              }}
                                            >
                                              <KTSVG
                                                path='/media/icons/duotune/archive-fill.svg'
                                                className='svg-icon-3'
                                              />
                                            </button>
                                            <button
                                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                              data-bs-toggle='tooltip'
                                              data-bs-placement='top'
                                              data-bs-trigger='hover'
                                              title={t('Jadwal')}
                                              onClick={() => {
                                                setIDSector(subItem.sector_id)
                                                setProvinceName(subItem.province?.region_name)
                                                setCityName(subItem.city?.city_name)
                                                setProductName(subItem.product_name)
                                                formattingTon(subItem.fixed_quantum)
                                                setReqeustQuantum(subItem.request_quantum)
                                                setJadwalID(subItem.id)
                                                setShowJadwal(true)
                                              }}
                                            >
                                              <KTSVG
                                                path='/media/icons/duotune/calendar-check-fill.svg'
                                                className='svg-icon-3'
                                              />
                                            </button>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                  {/* end::Table body */}
                                </table>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      <tr className='d-flex jusify-content-center w-100 align-items-center'>
                        <td className='view td-order-2 d-flex td-freeze'>
                          <div className='d-flex justify-content-center align-items-center p-3'>
                            <input
                              className='form-check-input me-2'
                              type='checkbox'
                              id={'checkbox' + _index}
                              value={_index}
                              onClick={() => onclickCheckBox(_index)}
                            />
                            <button
                              className='iconArow d-flex justify-content-center align-items-center me-2'
                              data-target={'target' + item['id']}
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t(tooltip)}
                              onClick={handleOpen}
                            >
                              {/* <KTSVG
                                    path='/media/icons/duotune/arrows/arrow-down.svg'
                                    className='svg-1'
                                  /> */}
                            </button>
                            <span
                              className=' fw-semibold p-0 fs-6'
                              // onClick={() => handleToAmandemen()}
                            >
                              SIP{item['SIP_number']}
                            </span>
                          </div>
                        </td>
                        <td className='td-order-6 text-center td-freeze'>
                          <span className='fs-6 d-block'>
                            A{item['pengajuan_order']?.po_number}
                          </span>
                        </td>
                        <td className='td-order-4 text-center td-freeze'>
                          <span className=' fw-semibold  d-block fs-6'>
                            {item['customer']?.title} {item['customer']?.name}
                          </span>
                        </td>
                        <td className='td-order-2 text-center'>
                          <span className='d-block fs-6'>
                            {item['perihal'] == 'PO001' ? (
                              <span className='badge badge-light-success'>{t('Penjualan')}</span>
                            ) : (
                              <span className='badge badge-light-primary'>
                                {t('Non-Penjualan')}
                              </span>
                            )}
                          </span>
                        </td>
                        <td className='td-order-3 text-center'>
                          <span className=' fw-semibold  d-block fs-6'>{t(item.sector?.name)}</span>
                        </td>
                        <td className='td-order-3 text-center'>
                          <span className=' fw-semibold  d-block fs-6'>{item['anper']?.name}</span>
                        </td>
                        <td className='td-order-2 text-center'>
                          <span className=' fw-semibold  d-block fs-6'>
                            {item.created_at.slice(0, 10)}
                          </span>
                        </td>
                        <td className='td-order-2 text-center'>
                          <span className=' fw-semibold  d-block fs-6'>
                            {item['estimate_date']?.slice(0, 10)}
                          </span>
                        </td>
                        <td className='td-order-2 text-center'>
                          <span className=' fw-semibold  d-block fs-6'>
                            {item.valid_date_from == null
                              ? ''
                              : dateFormatting(item.valid_date_from)}
                          </span>
                        </td>
                        <td className='td-order-2 text-center'>
                          <span className=' fw-semibold  d-block fs-6'>
                            {item.valid_date_to == null ? '' : dateFormatting(item.valid_date_to)}
                          </span>
                        </td>
                        <td className='td-order-2 text-center'>
                          <span className=' fw-semibold  d-block fs-6'>
                            {i18next.language === 'en'
                              ? item.total_quantum?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : item.total_quantum?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })}{' '}
                            {item.sector_id === 3 ? 'MT' : 'Ton'}
                          </span>
                        </td>
                        <td className='td-order-2 text-center'>
                          <span className=' fw-semibold  d-block fs-6'>
                            {(item.sector_id != 3 ? 'Rp' : 'USD') +
                              (i18next.language === 'en'
                                ? item.total_price?.toLocaleString('en', {maximumFractionDigits: 4})
                                : item.total_price?.toLocaleString('id', {
                                    maximumFractionDigits: 4,
                                  }))}
                          </span>
                        </td>
                        <td className='td-order-3 text-center'>
                          <span className='d-block fs-6'>
                            {item['status_text'] == 'Pengajuan Amandemen' ||
                            item['status_text'] == 'Amandemen' ||
                            item['status_text'] == 'Diamandemen Customer' ||
                            item['status_text'] == 'Telah Diamandemen' ? (
                              <span className='badge badge-light-info'>{t('Amandemen')}</span>
                            ) : item['status'] === 1 ? (
                              <span className='badge badge-light-primary'>
                                {t(item['status_text'])}
                              </span>
                            ) : item['status'] === 2 ? (
                              <span className='badge badge-light-warning'>
                                {t(item['status_text'])}
                              </span>
                            ) : item['status'] === 3 ? (
                              <span className='badge badge-light-primary'>
                                {t(item['status_text'])}
                              </span>
                            ) : item['status'] === 4 ? (
                              <span className='badge badge-light-success'>
                                {t(item['status_text'])}
                              </span>
                            ) : item['status'] === 5 ? (
                              <span className='badge badge-light-success'>
                                {t(item['status_text'])}
                              </span>
                            ) : item['status'] === 6 ? (
                              <span className='badge badge-light-primary'>
                                {t(item['status_text'])}
                              </span>
                            ) : item['status'] === 7 ? (
                              <span className='badge badge-light-warning'>
                                {t(item['status_text'])}
                              </span>
                            ) : item['status'] === 8 ? (
                              <span className='badge badge-light-primary'>
                                {t(item['status_text'])}
                              </span>
                            ) : item['status'] === 9 ? (
                              <span className='badge badge-light-warning'>
                                {t(item['status_text'])}
                              </span>
                            ) : (
                              <span className='badge badge-light-danger'>
                                {t(item['status_text'])}
                              </span>
                            )}
                          </span>
                        </td>
                        <td className='td-order-2 text-center'>
                          <div
                            className='d-flex p-0 justify-content-center'
                            style={{marginTop: '1px', marginBottom: '1.5px'}}
                          >
                            {/* <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title='Detail'
                              onClick={() => handleToAmandemen()}
                            >
                              <KTSVG
                                path='/media/icons/duotune/file-text-fill.svg'
                                className='svg-icon-3'
                              />
                            </button> */}

                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('order-lampiran')}
                              onClick={() => {
                                setParam('sip')
                                tampilUpload(item.id, 'sip')
                              }}
                            >
                              <KTSVG
                                path='/media/icons/duotune/archive-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    </table>
                    <div className='d-flex lefttt'>
                      <div className='table-responsive sub-table' style={{borderRadius: '8px'}}>
                        <table className='table'>
                          <tr className='fold' id={'target' + item['id']}>
                            <td className='fold-wrapperContent'>
                              <div className='fold-content' style={{padding: '0'}}>
                                <table className='table-border table-fix'>
                                  {/* begin::Table head */}
                                  <thead>
                                    <tr className='fw-bold  border-bottom'>
                                      <th
                                        className='text-center th2-freeze'
                                        style={{padding: '1rem 2.5rem'}}
                                      >
                                        {t('sub-order-item')}
                                      </th>
                                      <th
                                        className='text-center th2-freeze'
                                        style={{padding: '1rem 2.5rem'}}
                                      >
                                        Sales Org
                                      </th>
                                      <th
                                        className='text-center th2-freeze'
                                        style={{padding: '1rem 2.5rem'}}
                                      >
                                        {t('sub-order-incoterm')}
                                      </th>
                                      {item?.sector?.id != 3 && (
                                        <th
                                          className='text-center'
                                          style={{padding: '1rem 2.5rem'}}
                                        >
                                          {t('sub-order-wilayah')}
                                        </th>
                                      )}
                                      <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                        {t('sub-order-jenis')}
                                      </th>
                                      <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                        {t('Product Code')}
                                      </th>
                                      <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                        {t('sub-order-produk')}
                                      </th>
                                      <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                        {t('sub-order-spek')}
                                      </th>
                                      {item.sector_id != 2 ? (
                                        <>
                                          <th
                                            className='text-center'
                                            style={{padding: '1rem 2.5rem'}}
                                          >
                                            {t('kontrak-kuantum')}
                                          </th>
                                          <th
                                            className='text-center'
                                            style={{padding: '1rem 2.5rem'}}
                                          >
                                            {t('sub-order-kuantumD')}
                                          </th>
                                          <th
                                            className='text-center'
                                            style={{padding: '1rem 2.5rem'}}
                                          >
                                            {t('kontrak-harga')}
                                          </th>
                                          <th
                                            className='text-center'
                                            style={{padding: '1rem 2.5rem'}}
                                          >
                                            {t('sub-order-hargaD')}
                                          </th>
                                        </>
                                      ) : (
                                        <>
                                          <th
                                            className='text-center'
                                            style={{padding: '1rem 2.5rem'}}
                                          >
                                            {t('kontrak-kuantum')}
                                          </th>
                                          <th
                                            className='text-center'
                                            style={{padding: '1rem 2.5rem'}}
                                          >
                                            {t('kontrak-harga')}
                                          </th>
                                        </>
                                      )}
                                      {item.sector?.id == 1 || item.sector?.id == 3 ? (
                                        <></>
                                      ) : (
                                        <th
                                          className='text-center'
                                          style={{padding: '1rem 2.5rem'}}
                                        >
                                          {t('sub-order-gudang')}
                                        </th>
                                      )}
                                      <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                        Status
                                      </th>
                                      <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                        {t('order-aksi')}
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {item?.amendment_items?.map((subItem: any, _index: number) => (
                                      <tr key={subItem?.id ?? _index}>
                                        <td className='text-center td2-freeze'>
                                          {/* {subItem.id} */}
                                          {_index + 1}
                                        </td>
                                        {/* <td className='text-center'>{subItem.contract_id}</td> */}
                                        {/* {item.customer?.customer_account_group != "AR03" ? (
                                        <></>
                                      ) : (
                                        <td className='text-center'>{subItem.produsen?.name}</td>
                                      )} */}
                                        <td className='text-center td2-freeze'>
                                          {subItem.produsen?.name}
                                        </td>
                                        {subItem.sector_id == 2 ? (
                                          <>
                                            {subItem.incoterm2 == null ? (
                                              <td className='text-center td2-freeze'>
                                                {subItem.incoterm1?.code}-{subItem.incoterm2_id}
                                              </td>
                                            ) : (
                                              <td className='text-center td2-freeze'>
                                                {subItem.incoterm1?.code}-{subItem.incoterm2?.code}
                                              </td>
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            {subItem.incoterm2 == null ? (
                                              <td className='text-center td2-freeze'>
                                                {subItem.incoterm1?.code}
                                                {subItem.incoterm2_id == null ||
                                                subItem.incoterm2_id == '0'
                                                  ? ''
                                                  : '-' + subItem.incoterm2_id}
                                              </td>
                                            ) : (
                                              <td className='text-center td2-freeze'>
                                                {subItem.incoterm1?.code}-{subItem.incoterm2?.code}
                                              </td>
                                            )}
                                          </>
                                        )}
                                        {subItem.sector_id != 3 && (
                                          <td className='text-center'>
                                            {subItem.province?.region_name},{' '}
                                            {subItem.city?.city_name}
                                          </td>
                                        )}
                                        <td className='text-center'>{subItem.product_type_desc}</td>
                                        <td className='text-center'>
                                          {parseInt(subItem.material_number) == 0
                                            ? ''
                                            : subItem.material_number.slice(-7)}
                                        </td>
                                        <td className='text-center'>{subItem.product_name}</td>
                                        <td className='text-center'>
                                          <OverlayTrigger
                                            trigger='hover'
                                            key={_index}
                                            placement='right'
                                            overlay={
                                              <Popover id={`popover-positioned-${_index}`}>
                                                <Popover.Body>{subItem.product_spec}</Popover.Body>
                                              </Popover>
                                            }
                                          >
                                            <p className='spec-slicee'>{subItem.product_spec}</p>
                                          </OverlayTrigger>
                                        </td>
                                        {item.sector_id != 2 ? (
                                          <>
                                            <td className='text-center'>
                                              {i18next.language === 'en'
                                                ? subItem.request_quantum?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  })
                                                : subItem.request_quantum?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  })}{' '}
                                              {subItem.sector_id === 3 ? 'MT' : 'Ton'}
                                            </td>
                                            <td className='text-center'>
                                              {i18next.language === 'en'
                                                ? subItem.fixed_quantum?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  })
                                                : subItem.fixed_quantum?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  })}{' '}
                                              {subItem.sector_id === 3 ? 'MT' : 'Ton'}
                                            </td>
                                            <td className='text-center'>
                                              {subItem.is_formulated_price ? (
                                                <>{t('Formulated Price')}</>
                                              ) : (
                                                <>
                                                  {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                                    (i18next.language === 'en'
                                                      ? subItem.request_price.toLocaleString('en', {
                                                          maximumFractionDigits: 4,
                                                        })
                                                      : subItem.request_price.toLocaleString('id', {
                                                          maximumFractionDigits: 4,
                                                        })) +
                                                    (item.sector_id != 3 ? '/Ton' : '/MT')}
                                                </>
                                              )}
                                            </td>
                                            <td className='text-center'>
                                              {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                                (i18next.language === 'en'
                                                  ? subItem.fixed_price.toLocaleString('en', {
                                                      maximumFractionDigits: 4,
                                                    })
                                                  : subItem.fixed_price.toLocaleString('id', {
                                                      maximumFractionDigits: 4,
                                                    })) +
                                                (item.sector_id != 3 ? '/Ton' : '/MT')}
                                            </td>
                                          </>
                                        ) : (
                                          <>
                                            <td className='text-center'>
                                              {i18next.language === 'en'
                                                ? subItem.fixed_quantum?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  })
                                                : subItem.fixed_quantum?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  })}{' '}
                                              {subItem.sector_id === 3 ? 'MT' : 'Ton'}
                                            </td>
                                            <td className='text-center'>
                                              {'Rp' + i18next.language === 'en'
                                                ? subItem.fixed_price.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  })
                                                : subItem.fixed_price.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  })}
                                              /{subItem.sector_id === 3 ? 'MT' : 'Ton'}
                                            </td>
                                          </>
                                        )}
                                        {item.sector?.id == 1 || item.sector?.id == 3 ? (
                                          <></>
                                        ) : (
                                          <td className='text-center'>{subItem.plant_desc}</td>
                                        )}
                                        <td className='text-center'>
                                          <span className='d-block '>
                                            {subItem['status_text'] == 'Pengajuan Amandemen' ||
                                            subItem['status_text'] == 'Amandemen' ||
                                            subItem['status_text'] == 'Diamandemen Customer' ||
                                            subItem['status_text'] == 'Telah Diamandemen' ? (
                                              <span className='badge badge-light-info'>
                                                {t('Amandemen')}
                                              </span>
                                            ) : subItem['status'] == '0' ? (
                                              <span className='badge badge-light-success'>
                                                {t(subItem['status_text'])}
                                              </span>
                                            ) : subItem['status'] == '1' ? (
                                              <span className='badge badge-light-primary'>
                                                {t(subItem['status_text'])}
                                              </span>
                                            ) : subItem['status'] == '2' ? (
                                              <span className='badge badge-light-warning'>
                                                {t(subItem['status_text'])}
                                              </span>
                                            ) : subItem['status'] == '3' ? (
                                              <span className='badge badge-light-warning'>
                                                {t(subItem['status_text'])}
                                              </span>
                                            ) : subItem['status'] == '4' ? (
                                              <>
                                                {subItem['status_text'].match('Partially') ? (
                                                  <span className='badge badge-light-warning'>
                                                    {t(subItem['status_text'])}
                                                  </span>
                                                ) : (
                                                  <span className='badge badge-light-success'>
                                                    {t(subItem['status_text'])}
                                                  </span>
                                                )}
                                              </>
                                            ) : subItem['status'] == '5' ? (
                                              <span className='badge badge-light-success'>
                                                {t(subItem['status_text'])}
                                              </span>
                                            ) : subItem['status'] == '6' ? (
                                              <span className='badge badge-light-success'>
                                                {t(subItem['status_text'])}
                                              </span>
                                            ) : subItem['status'] == '7' ? (
                                              <span className='badge badge-light-success'>
                                                {t(subItem['status_text'])}
                                              </span>
                                            ) : (
                                              <span className='badge badge-light-danger'>
                                                {t(subItem['status_text'])}
                                              </span>
                                            )}
                                          </span>
                                        </td>
                                        <td className='text-center'>
                                          <div className='d-flex justify-content-center align-items-center'>
                                            <button
                                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-1 me-1'
                                              data-bs-toggle='tooltip'
                                              data-bs-placement='top'
                                              data-bs-trigger='hover'
                                              title='Detail'
                                              onClick={() => {
                                                setTempDetail(subItem)
                                                setShowDetail(true)
                                              }}
                                            >
                                              <KTSVG
                                                path='/media/icons/duotune/file-text-fill.svg'
                                                className='svg-icon-3'
                                              />
                                            </button>
                                            <button
                                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                              data-bs-toggle='tooltip'
                                              data-bs-placement='top'
                                              data-bs-trigger='hover'
                                              title={t('order-lampiran')}
                                              onClick={() => {
                                                tampilUpload(subItem.id, 'order-item')
                                              }}
                                            >
                                              <KTSVG
                                                path='/media/icons/duotune/archive-fill.svg'
                                                className='svg-icon-3'
                                              />
                                            </button>
                                            <button
                                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                              data-bs-toggle='tooltip'
                                              data-bs-placement='top'
                                              data-bs-trigger='hover'
                                              title={t('Jadwal')}
                                              onClick={() => {
                                                setIDSector(subItem.sector_id)
                                                setProvinceName(subItem.province?.region_name)
                                                setCityName(subItem.city?.city_name)
                                                setProductName(subItem.product_name)
                                                formattingTon(subItem.fixed_quantum)
                                                setReqeustQuantum(subItem.request_quantum)
                                                setJadwalID(subItem.id)
                                                setShowJadwal(true)
                                              }}
                                            >
                                              <KTSVG
                                                path='/media/icons/duotune/calendar-check-fill.svg'
                                                className='svg-icon-3'
                                              />
                                            </button>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                  {/* end::Table body */}
                                </table>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </>
                )}
              </>
            ))
          )}
          {/* Table Content */}
        </div>
        {/* end::Table container */}
      </div>
      <div className='d-flex justify-content-end my-5'>
        <Link to='/management/order/create' className='me-2'>
          <Button className='btn btn-secondary'>{t('order-kembali')}</Button>
        </Link>
        <div className='me-2'>
          <Button
            hidden={buttonFlag ? false : true}
            onClick={() => handleToAmandemen()}
            className='btn btn-primary'
          >
            {t('amandement')}
          </Button>
        </div>
      </div>

      <div className='my-5'>
        <Modal
          show={showJadwal}
          onHide={() => {
            setShowJadwal(false)
            setJadwalID('')
          }}
          centered
          size='xl'
          backdrop='static'
          keyboard={false}
          scrollable
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {idSektor != 3 ? provinceName + ', ' + cityName + ' | ' : ''}
              {productName} | {fixedQuantum} Ton
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <span style={{fontSize: '15px'}} className='fw-bold d-block'>
              {t('Jadwal')}
            </span>
            <AddRemoveJadwal id={jadwalID} is_amendment={'false'} />
          </Modal.Body>
        </Modal>

        <Modal
          size='lg'
          show={showUpload}
          onHide={() => setShowUpload(false)}
          backdrop='static'
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('order-fileBox')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {allFiles.length < 1 || allFiles.length == undefined ? (
              <></>
            ) : (
              <>
                <div className='table-responsive mt-4 bdr'>
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead className='fw-bold border-bottom'>
                      <tr className=''>
                        <th className='text-center'>{t('order-noo')}</th>
                        <th className='text-center'>{t('order-keterangan')}</th>
                        <th className='text-center'>{t('order-tglUpload')}</th>
                        {/* <th className='text-center'>{t('User Code')}</th> */}
                        <th className='text-center'>{t('order-user')}</th>
                        <th className='text-center'>{t('order-aksi')}</th>
                      </tr>
                    </thead>
                    {allFiles.map((data: any, _index: any) => (
                      <tbody key={data?.id ?? _index}>
                        <tr className=''>
                          <td className='text-center'>
                            <label>{_index + 1}</label>
                          </td>
                          <td className='text-center'>
                            <label>{data.description}</label>
                          </td>
                          <td className='text-center'>
                            <label>{dateformat(data.updated_at)}</label>
                          </td>
                          {/* <td className='text-center'>
                            <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                          </td> */}
                          <td className='text-center'>
                            {data.user?.customer_code == null ? (
                              <label>{data.user?.name}</label>
                            ) : (
                              <label>{data.user?.customer?.name}</label>
                            )}
                          </td>
                          <td className='text-center'>
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('unduh')}
                              onClick={() =>
                                window.open(
                                  data.file_path + `&token=${localStorage.getItem('token')}`
                                )
                              }
                            >
                              <KTSVG
                                path='/media/icons/duotune/arrow-down-square-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>

        <Modal
          show={showDetail}
          onHide={() => setShowDetail(false)}
          backdrop='static'
          keyboard={false}
          centered
          scrollable
          size='xl'
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('Detail Sub Order')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {tempDetail?.sector_id == 1 && (
              <Row>
                <Col md='6'>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>Sales Org</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.produsen?.name}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.incoterm1?.code}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        type='text'
                        value={tempDetail.province?.region_name}
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.product_type_desc}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          i18next.language === 'en'
                            ? parseFloat(tempDetail?.fixed_quantum).toLocaleString('en', {
                                maximumFractionDigits: 4,
                              }) + ' Ton'
                            : parseFloat(tempDetail?.fixed_quantum).toLocaleString('id', {
                                maximumFractionDigits: 4,
                              }) + ' Ton'
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col sm={4}>
                      <p className='fs-6'>{t('Shipping Tolerance')}</p>
                    </Col>
                    <Col sm={8}>
                      <Form.Control
                        placeholder={t('Shipping Tolerance')}
                        size='sm'
                        type='text'
                        id='shipping'
                        value={
                          tempDetail?.shipping_tolerance == 0
                            ? ''
                            : tempDetail?.shipping_tolerance + '%'
                        }
                        disabled
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.payment_type_1_desc}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='fs-6'>{t('keterangan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.payment_note}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='fs-6 mt-3'>{t('segment')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={t(tempDetail?.segment_name)}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('End Customer')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          tempDetail.end_user_multiple
                            ? handleShowValue(tempDetail.end_user)
                            : tempDetail.end_user
                        }
                        as='textarea'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                </Col>
                <Col md='6'>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={t(tempDetail.sector?.name)}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                    </Col>
                    <Col md={8}>
                      {tempDetail?.incoterm2 == null ? (
                        <Form.Control
                          value={
                            tempDetail?.incoterm2_id == null || tempDetail?.incoterm2_id == '0'
                              ? ''
                              : tempDetail?.incoterm2_id
                          }
                          type='text'
                          disabled
                          size='sm'
                        />
                      ) : (
                        <Form.Control
                          value={tempDetail?.incoterm2?.code}
                          type='text'
                          disabled
                          size='sm'
                        />
                      )}
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        type='text'
                        value={tempDetail.city?.city_name}
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.product_name}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-2'>
                    <Col md={4}>
                      <p className='fs-6'>{t('Harga Pengajuan')}/Ton</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          'Rp' + i18next.language === 'en'
                            ? parseFloat(tempDetail?.fixed_price).toLocaleString('en', {
                                maximumFractionDigits: 4,
                              })
                            : parseFloat(tempDetail?.fixed_price).toLocaleString('id', {
                                maximumFractionDigits: 4,
                              })
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col sm={4}>
                      <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                    </Col>
                    <Col sm={8} className='d-flex justify-content-start'>
                      <Form.Check
                        reverse
                        name='ppn'
                        className='mt-5 mb-2'
                        type='checkbox'
                        id='ckbox-ppn'
                        checked={tempDetail?.include_ppn}
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.payment_type_2_desc}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.product_spec}
                        as='textarea'
                        style={{height: '40px'}}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.notes}
                        type='text'
                        as='textarea'
                        style={{height: '40px'}}
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}

            {tempDetail?.sector_id == 2 && (
              <Row>
                <Col md='6'>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>Sales Org</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.produsen?.name}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.incoterm1?.code}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        type='text'
                        value={tempDetail.province?.region_name}
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control value={tempDetail.plant_desc} type='text' disabled size='sm' />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.product_name}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          i18next.language === 'en'
                            ? parseFloat(tempDetail?.fixed_quantum).toLocaleString('en', {
                                maximumFractionDigits: 4,
                              }) + ' Ton'
                            : parseFloat(tempDetail?.fixed_quantum).toLocaleString('id', {
                                maximumFractionDigits: 4,
                              }) + ' Ton'
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.payment_type_1_desc}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='fs-6'>{t('keterangan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.payment_note}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                </Col>
                <Col md='6'>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={t(tempDetail.sector?.name)}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                    </Col>
                    <Col md={8}>
                      {tempDetail?.incoterm2 == null ? (
                        <Form.Control
                          value={
                            tempDetail?.incoterm2_id == null || tempDetail?.incoterm2_id == '0'
                              ? ''
                              : tempDetail?.incoterm2_id
                          }
                          type='text'
                          disabled
                          size='sm'
                        />
                      ) : (
                        <Form.Control
                          value={tempDetail?.incoterm2?.code}
                          type='text'
                          disabled
                          size='sm'
                        />
                      )}
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        type='text'
                        value={tempDetail.city?.city_name}
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.product_type_desc}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.product_spec}
                        as='textarea'
                        style={{height: '40px'}}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='fs-6 mt-3'>{t('Price')}/Ton</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          'Rp' + i18next.language === 'en'
                            ? parseInt(tempDetail?.fixed_price).toLocaleString('en', {
                                maximumFractionDigits: 4,
                              })
                            : parseInt(tempDetail?.fixed_price).toLocaleString('id', {
                                maximumFractionDigits: 4,
                              })
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('End Customer')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          tempDetail.end_user_multiple
                            ? handleShowValue(tempDetail.end_user)
                            : tempDetail.end_user
                        }
                        as='textarea'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.notes}
                        type='text'
                        as='textarea'
                        style={{height: '40px'}}
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}

            {tempDetail?.sector_id == 3 && (
              <Row>
                <Col md='6'>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>Sales Org</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.produsen?.name}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.incoterm1?.code}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.product_type_desc}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          i18next.language === 'en'
                            ? parseFloat(tempDetail?.fixed_quantum).toLocaleString('en', {
                                maximumFractionDigits: 4,
                              }) + ' MT'
                            : parseFloat(tempDetail?.fixed_quantum).toLocaleString('id', {
                                maximumFractionDigits: 4,
                              }) + ' MT'
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col sm={4}>
                      <p className='fs-6'>{t('Shipping Tolerance')}</p>
                    </Col>
                    <Col sm={8}>
                      <Form.Control
                        placeholder={t('Shipping Tolerance')}
                        size='sm'
                        type='text'
                        id='shipping'
                        value={
                          tempDetail?.shipping_tolerance == 0
                            ? ''
                            : tempDetail?.shipping_tolerance + '%'
                        }
                        disabled
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.payment_type_1_desc}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='fs-6'>{t('keterangan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.payment_note}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('End Customer')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          tempDetail.end_user_multiple
                            ? handleShowValue(tempDetail.end_user)
                            : tempDetail.end_user
                        }
                        as='textarea'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                </Col>
                <Col md='6'>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={t(tempDetail.sector?.name)}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                    </Col>
                    <Col md={8}>
                      {tempDetail?.incoterm2 == null ? (
                        <Form.Control
                          value={
                            tempDetail?.incoterm2_id == null || tempDetail?.incoterm2_id == '0'
                              ? ''
                              : tempDetail?.incoterm2_id
                          }
                          type='text'
                          disabled
                          size='sm'
                        />
                      ) : (
                        <Form.Control
                          value={tempDetail?.incoterm2?.code}
                          type='text'
                          disabled
                          size='sm'
                        />
                      )}
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.product_name}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-2'>
                    <Col md={4}>
                      <p className='fs-6'>{t('Harga Pengajuan')}/MT</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          'USD' + i18next.language === 'en'
                            ? parseInt(tempDetail?.fixed_price).toLocaleString('en', {
                                maximumFractionDigits: 4,
                              })
                            : parseInt(tempDetail?.fixed_price).toLocaleString('id', {
                                maximumFractionDigits: 4,
                              })
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  {/* <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                              </Col>
                              <Col sm={8} className='d-flex justify-content-start'>
                                <Form.Check
                                  reverse
                                  name='ppn'
                                  className='mt-5 mb-2'
                                  type='checkbox'
                                  id='ckbox-ppn'
                                  checked={tempDetail?.include_ppn}
                                />
                              </Col>
                            </Row> */}
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.product_spec}
                        as='textarea'
                        style={{height: '40px'}}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.payment_type_2_desc}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.notes}
                        type='text'
                        as='textarea'
                        style={{height: '40px'}}
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
          </Modal.Body>
        </Modal>
      </div>

      {/* <div className='mb-5'>
        <Pagination paginate={paginateNumber} test={numberURL} />
      </div> */}
    </div>
  )
}

export {TableRevisiSIP}
